import { render, staticRenderFns } from "./PrintSection.vue?vue&type=template&id=54e9911f&"
import script from "./PrintSection.vue?vue&type=script&lang=js&"
export * from "./PrintSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports